// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickContainer_container__lsuvj {
  padding: 0 max((100vw - 1200px) / 2, 0.5em);
}`, "",{"version":3,"sources":["webpack://./src/components/ClickContainer/ClickContainer.module.scss"],"names":[],"mappings":"AAAA;EACE,2CAAA;AACF","sourcesContent":[".container {\n  padding: 0 Max(calc(calc(100vw - 1200px) / 2), 0.5em);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ClickContainer_container__lsuvj`
};
export default ___CSS_LOADER_EXPORT___;
